export default "__VITE_ASSET__219f5eb1__"